<template>
    <k-tabbar v-if="showTabbar" class="jd-tabbar" v-model="active" active-color="#CEA065" :z-index="999">
        <k-tabbar-item name="home" icon="home" url="/">首页</k-tabbar-item>
        <k-tabbar-item name="pai" icon="pai" :url="paiUrl">拍卖</k-tabbar-item>
        <k-tabbar-item name="shop" icon="shop" :url="shopUrl">商城</k-tabbar-item>
        <k-tabbar-item name="jianding" icon="jian" to="/">鉴定</k-tabbar-item>
        <k-tabbar-item name="my" icon="user2" :url="myUrl">我的</k-tabbar-item>
<!--        <k-tabbar-item name="myOrder" icon="task-list" to="/my/order">订单</k-tabbar-item>-->
<!--        <k-tabbar-item name="appraiser" icon="manager" to="/appraiser">专家</k-tabbar-item>-->
    </k-tabbar>
</template>

<script>
    import {HOST_BBS, HOST_PAI, HOST_WEB} from "../../utils/xp.v1"
    import {inXSApp} from "../../utils/wz.v2";
    export default {
        name: "jd-tabbar",
        data () {
            return {
                active : "jianding",
                paiUrl : `https://${HOST_PAI}`,
                shopUrl : `https://${HOST_BBS}/plugin.php?id=wei_shop:wei_shop`,
                myUrl   : `https://${HOST_WEB}/my/index`,
            }
        },
        computed:{
            showTabbar(){
                return inXSApp() ? false : true;
            }
        }
    }
</script>